import { createRoot, Root } from "react-dom/client";
import { QrCode } from "./qr";

let modalRoot: Root | null = null;

function closeQrModal() {
  modalRoot?.unmount();
  modalRoot = null;
  document.querySelector(".student-qr-overlay")?.remove();
}

function QrModal({ studentName, url, expiresInSeconds }: { studentName: string; url: string; expiresInSeconds: number }) {
  return <div className="student-qr-overlay" onMouseDown={(event) => { if (event.target === event.currentTarget) closeQrModal(); }}>
    <section className="student-qr-dialog" role="dialog" aria-modal="true" aria-label={`QR code de ${studentName}`}>
      <button className="student-qr-close" onClick={closeQrModal} aria-label="Fermer">×</button>
      <small>Accès élève temporaire</small>
      <h2>{studentName}</h2>
      <div className="student-qr-code"><QrCode value={url} size={260} title={`QR code de ${studentName}`} /></div>
      <strong>Scanne ce QR code</strong>
      <p>L’élève est connecté directement à son espace CompetenceO. Ce QR est utilisable une seule fois et expire dans {Math.round(expiresInSeconds / 60)} minutes.</p>
      <button className="student-qr-done" onClick={closeQrModal}>Fermer</button>
    </section>
  </div>;
}

function selectedStudentIdentity() {
  const selectedCard = document.querySelector<HTMLElement>(".student-card.selected");
  const fullName = selectedCard?.getAttribute("aria-label")?.trim() ?? "";
  const classId = localStorage.getItem("competenceo-active-class-v1") ?? "";
  if (!fullName || !classId) return null;
  try {
    const students = JSON.parse(localStorage.getItem(`competenceo-students-v1:${classId}`) ?? "[]") as Array<{ id: string; firstName: string; lastName: string }>;
    const matches = students.filter((student) => `${student.firstName} ${student.lastName}`.trim() === fullName);
    return matches.length === 1 ? { classId, studentId: matches[0].id, fullName } : null;
  } catch { return null; }
}

async function openStudentQr(button: HTMLButtonElement) {
  const identity = selectedStudentIdentity();
  if (!identity) {
    window.alert("Impossible d’identifier cet élève de façon unique. Vérifie qu’il n’y a pas deux élèves avec exactement le même nom.");
    return;
  }
  const previous = button.textContent;
  button.disabled = true;
  button.textContent = "Création du QR…";
  try {
    const response = await fetch("/api/student/qr-access", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ classId: identity.classId, studentId: identity.studentId }),
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(body.error ?? "QR code indisponible");
    closeQrModal();
    const host = document.createElement("div");
    host.className = "student-qr-overlay";
    document.body.appendChild(host);
    modalRoot = createRoot(host);
    modalRoot.render(<QrModal studentName={body.studentName ?? identity.fullName} url={body.url} expiresInSeconds={Number(body.expiresInSeconds ?? 600)} />);
  } catch (reason) {
    window.alert(reason instanceof Error ? reason.message : "QR code indisponible");
  } finally {
    button.disabled = false;
    button.textContent = previous;
  }
}

function ensureQrButton() {
  const panelHead = document.querySelector<HTMLElement>(".evaluation-panel.open .panel-head");
  if (!panelHead) return;
  const selectedCard = document.querySelector(".student-card.selected");
  if (!selectedCard) return;
  if (panelHead.querySelector("[data-student-qr-button]")) return;
  const button = document.createElement("button");
  button.type = "button";
  button.className = "open-dashboard student-qr-trigger";
  button.dataset.studentQrButton = "true";
  button.textContent = "QR code élève";
  button.addEventListener("click", () => void openStudentQr(button));
  panelHead.appendChild(button);
}

const observer = new MutationObserver(ensureQrButton);
observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
window.setTimeout(ensureQrButton, 0);
